import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
export var feedbackItemHeight = 20;
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            display: 'flex',
            flexDirection: 'column',
            width: 64,
            backgroundColor: palette.background.default
        },
        topContent: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'stretch',
            flexWrap: 'nowrap',
            height: feedbackItemHeight
        },
        bottomContent: {
            display: 'flex',
            alignItems: 'stretch',
            flexWrap: 'nowrap',
            height: 8
        }
    });
});
export var FeedbackContainer = function (_a) {
    var left = _a.left, right = _a.right, bottom = _a.bottom;
    var classes = useStyles();
    return React.createElement(Box, { className: classes.root },
        React.createElement(Box, { className: classes.topContent },
            React.createElement(Box, null, left),
            right),
        bottom && React.createElement(Box, { className: classes.bottomContent }, bottom));
};
